// extracted by mini-css-extract-plugin
export default {"container":"bas_SXNxm"};